var CompaniesComponentModule = /** @class */ (function () {
    function CompaniesComponentModule() {
    }
    return CompaniesComponentModule;
}());
export { CompaniesComponentModule };
